import KioskModal from '../KioskModal';

function IdleScreenTimeModal({ show, onContinue, onQuit }) {
  return (
    <KioskModal show={show} onHide={onContinue} labelledBy="idle-title" confirm>
      <h2 id="idle-title" className="readyModal__title">
        Are you still there?
      </h2>
      <p className="idleModal__copy">
        Your session is about to expire due to inactivity. Continue now to keep creating.
      </p>
      <div className="readyModal__actions">
        <button
          type="button"
          className="readyModal__button readyModal__button--submit"
          onClick={onContinue}
        >
          Stay & continue
        </button>
        <button
          type="button"
          className="readyModal__button readyModal__button--edit"
          onClick={onQuit}
        >
          Quit
        </button>
      </div>
    </KioskModal>
  );
}

export default IdleScreenTimeModal;
